module.exports = __webpack_public_path__ + "img/registrosEgresos.002014ee.svg";